<template>
  <div class="tab">
    <h3>数据申请</h3>
    <div>
      <form>
        <p>
          <span>姓名</span>
          <input type="text" v-model="formMess.name" />
        </p>
        <p>
          <span>职称</span>
          <input type="text" v-model="formMess.post" />
        </p>
        <p>
          <span>工作单位</span>
          <input type="text" v-model="formMess.WorkUnit" />
        </p>
        <p>
          <span>专业领域</span>
          <input type="text" v-model="formMess.ProfessionalField" />
        </p>
        <p>
          <span>联系电话</span>
          <input type="text" v-model="formMess.phone" />
        </p>
        <p>
          <span>电子邮箱</span>
          <input type="text" v-model="formMess.email" />
        </p>
        <p>
          <span>申请数据内容</span>
          <textarea v-model="formMess.content"></textarea>
        </p>
      </form>
      <span class="subtn" @click="onSubmit()">提交</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "dataApply",
  data() {
    return {
      formMess: {
        name: "",
        post: "",
        WorkUnit: "",
        ProfessionalField: "",
        phone: "",
        email: "",
        content: ""
      },
      checkdata: [
        {
          inspect: "", // 待检测的字段
          msg: "姓名" // 空值返回的提示
        },
        {
          inspect: "",
          msg: "职称"
        },
        {
          inspect: "",
          msg: "工作单位"
        },
        {
          inspect: "",
          msg: "专业领域"
        },
        {
          inspect: "",
          msg: "联系电话",
          reg: "^[1][3,4,5,7,8][0-9]{9}$"
        },
        {
          inspect: "",
          msg: "电子邮箱",
          reg: "^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$"
        },
        {
          inspect: "",
          msg: "申请数据内容"
        }
      ]
    };
  },
  methods: {
    // 判定是否合规
    have_empty(arr) {
      for (let key in arr) {
        if (arr[key].inspect && arr[key].reg) {
          // 有值并且有规则执行验证
          let reg = new RegExp(arr[key].reg);
          var rightEnd = reg.test(arr[key].inspect);
          if (!rightEnd) {
            console.log("请输入正确的" + arr[key].msg);
            this.$message({
              showClose: true,
              message: "请输入正确的" + arr[key].msg,
              type: "error"
            });
            return false;
          }
        } else if (!arr[key].inspect) {
          console.log("请输入" + arr[key].msg);
          this.$message({
            showClose: true,
            message: "请输入" + arr[key].msg,
            type: "error"
          });
          return false;
        }
      }
      return true;
    },
    assignData() {
      var arrForm = [];
      for (let key in this.formMess) {
        arrForm.push(key);
      }
      for (let i = 0; i < this.checkdata.length; i++) {
        this.checkdata[i].inspect = this.formMess[arrForm[i]];
      }
    },
    onSubmit() {
      this.assignData();
      var end = this.have_empty(this.checkdata);
      if (!end) return; // 判定验证结果
      let formData = new FormData();
      for (var key in this.formMess) {
        formData.append(key, this.formMess[key]);
      }
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Message/XinLiSuoDataApply",
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true,
        data: formData
      }).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "error"
          });
        }
        console.log(res);
      });
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>


// WEBPACK FOOTER //
// src/components/tabs/dataApply.vue